import { Box3, Object3D, OrthographicCamera, PerspectiveCamera } from "three";

import { computeBoundingBoxHelper } from "./vessel3D/vessels/helpers/computeBoundingBoxHelper";
import { fitCameraToBoundingBox } from "./fitCameraToBoundingBox";

export async function fitCameraToMainScene({
  camera,
  object,
  offset,
  width,
  height,
  initialY,
  smooth,
  setCameraInPositionAndTarget,
}: {
  camera: OrthographicCamera | PerspectiveCamera;
  object: Object3D;
  offset: number;
  width: number;
  height: number;
  initialY: number | undefined;
  smooth: number;
  onEnd?: () => void;
  setCameraInPositionAndTarget: (
    cameraName: "perspective" | "orthographic",
    cameraPosition?: { x: number; y: number; z: number },
    controlsTarget?: { x: number; y: number; z: number },
    smooth?: number,
  ) => Promise<void>;
}): Promise<void> {
  if (!object) {
    console.warn("Object is not a group or is undefined");
    return;
  }
  const sg = object.getObjectByName("SingleGeometryMesh");
  if (!sg) {
    return;
  }

  const sgBoundingBox = computeBoundingBoxHelper(sg);

  if (!sgBoundingBox) {
    console.warn("SG bounding box is not defined");
    return;
  }

  const boundingBox = sgBoundingBox.box;

  const cg = object.getObjectByName("containers-group");

  if (cg) {
    const cgBoundingBox = new Box3();
    cgBoundingBox.setFromObject(cg);

    boundingBox.union(cgBoundingBox);
  }

  await fitCameraToBoundingBox({
    camera,
    boundingBox,
    offset,
    width,
    height,
    initialY: initialY ?? (boundingBox.max.y + boundingBox.min.y) / 2,
    smooth,
    setCameraInPositionAndTarget,
  });
}
